<template>
  <div class="panel panoramaview-panel" id="panorama_panel">
    <div class="panel-content column no-wrap">
      <div id="buttons_panorama">
        <div class="row q-pb-xs">
          <slot name="title">
            <div class="panel-title space">{{ t('title') }}</div>
          </slot>
          <q-space />
          <panorama-show-lateral-button />
          <panorama-campaigns-dropdown />
          <panorama-options-dropdown>
            <template v-slot:before>
              <q-item
                clickable
                v-close-popup
                label="Obrir finestra flotant"
                @click="showDrawingNavigationWindow"
              >
                <q-item-section avatar>
                  <q-avatar icon="play_arrow"/>
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ $t('tools.panorama.drawingNavigationPanel') }}</q-item-label>
                  <q-item-label caption>{{ $t('tools.panorama.drawingNavigationPanelDescription') }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-separator/>
            </template>
            <template v-slot:after-enable-disbale>
              <q-item
                clickable
                :disable="!latLng"
                v-close-popup
                @click="horizontal = !horizontal"
              >
                <q-item-section avatar>
                  <q-avatar icon="las la-columns" :class="horizontal ? '' : 'rotate-90'"/>
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ horizontal ? $t('tools.panorama.splitVertially') : $t('tools.panorama.splitHorizontaly') }}</q-item-label>
                </q-item-section>
              </q-item>
            </template>
            <template v-slot:after>
              <q-item v-if="panoramasLayer" clickable v-close-popup @click="addLayer(panoramasLayer)">
                <q-item-section avatar> <q-avatar icon="layers" text-color="black" /></q-item-section>
                <q-item-section>
                  <q-item-label>{{ t('addLayer') }}</q-item-label>
                  <q-item-label caption>{{ t('addLayerCaption') }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item v-if="ambitsLayer" clickable v-close-popup @click="addLayer(ambitsLayer)">
                <q-item-section avatar> <q-avatar icon="layers" text-color="black" /></q-item-section>
                <q-item-section>
                  <q-item-label>{{ t('addAmbit') }}</q-item-label>
                  <q-item-label caption>{{ t('addAmbitCaption') }}</q-item-label>
                </q-item-section>
              </q-item>
              <q-item
                clickable
                v-close-popup
                @click="center"
                :disable="!latLng"
              >
                <q-item-section avatar> <q-avatar icon="room" text-color="black" /></q-item-section>
                <q-item-section>
                  <q-item-label>{{ t('centerMap') }}</q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </panorama-options-dropdown>
          <panorama-drawing-navigation
            v-on:measuring="cancelClickBehaviour"
            v-on:stopmeasuring="activateClickBehaviour"
          />
        </div>
      </div>
      <div v-if="help">
        <slot name="help">
        {{ t('help') }}
        </slot>
      </div>
      <div v-else class="full-height">
        <panorama-viewer
          :horizontal="horizontal"
          :offset="offset"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import { ClosePopup, QAvatar, QBtn, QBtnDropdown, QBtnGroup, QItem, QItemLabel, QItemSection, QList, QTooltip } from 'quasar'
// import { isInsideBoundary, closestPoint, getBoundaryAltitude } from 'src/lib/geometry'
import { ClosePopup, QAvatar, QItem, QItemLabel, QItemSection, QSeparator, QSpace } from 'quasar'
import { mapState } from 'vuex'
import proj4 from 'proj4'

import { lib } from '@giscube/geoportal'
const L = lib.L

import { projections } from 'src/lib/projections'
import MapiaPano from './Panorama/PanoramaOrientation.js'
import PanoramaViewer from './Panorama/PanoramaViewer.vue'
import PanoramaCampaignsDropdown from 'components/Panorama/PanoramaCampaignsDropdown.vue'
import PanoramaOptionsDropdown from './Panorama/PanoramaOptionsDropdown.vue'
import PanoramaShowLateralButton from './Panorama/PanoramaShowLateralButton.vue'
import PanoramaDrawingNavigation from './Panorama/PanoramaDrawingNavigation.vue'

export default {
  components: {
    PanoramaCampaignsDropdown, PanoramaShowLateralButton, PanoramaViewer, PanoramaOptionsDropdown, PanoramaDrawingNavigation, QAvatar, QItem, QItemLabel, QItemSection, QSeparator, QSpace
  },
  directives: {
    ClosePopup
  },
  data () {
    return {
      horizontal: this.$config.panoramas.horizontal,
      ambitsLayer: this.$config.panoramas.ambitsLayer,
      categories: this.$config.panoramas.categories,
      latLngClick: null,
      pano: null,
      panoramasBoundary: this.$config.panoramas.panoramasBoundary,
      panoramasPoints: this.$config.panoramas.panoramasPoints,
      panoramasLayer: this.$config.panoramas.panoramasLayer,
      help: !this.latLng,
      addPanoramasLayerSwitch: true
    }
  },
  computed: {
    ...mapState({
      map: state => state.map.mapObject,
      selectedCategory: state => state.panorama.selectedCategory,
      latLng: state => state.panorama.latLng,
      head: state => state.panorama.head,
      headFrom: state => state.panorama.headFrom,
      laterals: state => state.panorama.laterals,
      showLateral: state => state.panorama.showLateral,
      srcPannellum: state => state.panorama.srcPannellum
    }),
    offset () {
      let offset = this.horizontal ? '' : '- 20px'
      return `calc(100vh - ${document.getElementsByClassName('giscube-toolbar')[0].clientHeight}px - ${document.getElementById('buttons_panorama').clientHeight}px ${offset})`
    }
  },
  watch: {
    'map': 'mapChanged',
    'latLng': ['updateHeadFromClick', 'updatePano', 'updateMarker'],
    'head': 'updateOrientation',
    'pano.head': 'updateHeadFromPanoramaOrientation',
    'selectedCategory': 'positionChanged',
    'srcPannellum': function (srcPannellum) {
      this.help = false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.params.p) {
        const latlng = to.params.p.split(',')
        if (latlng && latlng.length > 0) {
          vm.latLngClick = {
            lat: latlng[0],
            lng: latlng[1]
          }
          vm.positionChanged()
        }
        vm.$router.replace({ params: { p: null } }).catch(() => {})
      }
    })
  },
  created () {
    this.addPanoramasLayer()

    if (!this.$config.panoramas.public && !this.$store.state.auth.username) {
      this.$router.push({ name: 'auth' })
    }
    this.$store.commit('setCurrentTool', true)
    if (!this.campaigns) {
      this.$store.dispatch('panorama/getCampaigns')
    }

    this.$store.commit('panorama/setSelectedCategory', this.$config.panoramas.categories && this.$config.panoramas.categories[0])

    proj4.defs(projections)
    this.mapChanged()
  },
  beforeDestroy () {
    this.removePanoramasLayer()

    if (this.marker) {
      this.marker.removeFrom(this.map)
    }
    if (this.pano && this.pano.clearGeometry) {
      this.pano.clearGeometry()
      this.pano = null
    }

    this.$store.commit('setCurrentTool', null)
    this.map.off('click', this.clickHandler)
    this.$store.commit('panorama/setShowDrawingNavigationWindow', false)
  },
  methods: {
    t (key, ...args) {
      return this.$t('tools.panorama.' + key, ...args)
    },
    activateLateral () {
      const isActive = this.showLateral
      if (!isActive) {
        this.$store.dispatch('panorama/selectLateral')
      } else {
        this.$store.commit('panorama/setSelectedLateral', null)
      }
      this.$store.commit('panorama/setShowLateral', !isActive)
    },
    addLayer (layer) {
      this.$store.dispatch('map/addLayer', layer)
    },
    addPanoramasLayer () {
      if (!this.panoramasLayer) {
        return
      }
      if (!this.$store || !this.$store.state || !this.$store.state.map || !this.$store.state.map.layers) {
        return
      }
      if (this.$store.state.map.layers.overlays && this.$store.state.map.layers.overlays.filter(layer => layer.id.plainRef === this.panoramasLayer.id.plainRef).length > 0) {
        this.addPanoramasLayerSwitch = false
      } else {
        this.$store.dispatch('map/addLayer', this.panoramasLayer)
      }
    },
    center () {
      if (!this.latLng) {
        return
      }
      this.map.panTo([this.latLng.lat, this.latLng.lng])
    },
    clickHandler (event) {
      this.latLngClick = event.latlng
      this.positionChanged()
    },
    onCategoryClick (category) {
      this.$store.commit('panorama/setSelectedCategory', category)
    },
    async mapChanged () {
      if (!this.map || !this.map.giscube) {
        return
      }

      this.map.on('click', this.clickHandler)

      if (this.query && this.$store.getters['map/bbox']().contains(this.query.latlng)) {
        this.latLngClick = this.query.latlng
      }

      let icon = L.icon({
        iconUrl: '',
        shadowUrl: '',
        iconSize: [40, 40],
        shadowSize: [50, 64],
        iconAnchor: [20, 35],
        shadowAnchor: [4, 62],
        popupAnchor: [-3, -76],
        className: 'panorama-view-marker'
      })
      icon.createIcon = function (oldIcon) {
        const div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div')
        div.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M192 64c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64s-64-28.654-64-64zm112 80h-11.36c-22.711 10.443-49.59 10.894-73.28 0H208c-26.51 0-48 21.49-48 48v104c0 13.255 10.745 24 24 24h16v104c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V320h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48zm85.642 189.152a72.503 72.503 0 0 1-29.01 27.009C391.133 365.251 480 385.854 480 416c0 46.304-167.656 64-224 64-70.303 0-224-20.859-224-64 0-30.123 88.361-50.665 119.367-55.839a72.516 72.516 0 0 1-29.01-27.009C74.959 343.395 0 367.599 0 416c0 77.111 178.658 96 256 96 77.249 0 256-18.865 256-96 0-48.403-74.967-72.606-122.358-82.848z"/></svg>'
        this._setIconStyles(div, 'icon')
        return div
      }

      const color = this.$config.panoramas.color || '#df0016'
      this.pano = new MapiaPano(this.map, color)
      if (this.latLng) {
        this.pano.setLatLng(this.latLng, this.head)
      }

      const latLng = this.latLng ? this.latLng : { lat: -9999, lng: -9999 }
      this.marker = L.marker(latLng, {
        draggable: true,
        icon: icon
      })
      this.marker.addTo(this.map)
      this.marker.on('drag', this.markerDrag)
      this.marker.on('dragend', this.markerDragEnd)
    },
    markerDrag () {
      if (this.pano) {
        this.pano.clearGeometry()
      }
    },
    markerDragEnd () {
      this.latLngClick = this.marker.getLatLng()
      this.positionChanged()
    },
    positionChanged () {
      if (!this.latLngClick) { return }
      if (this.help && this.latLngClick) { this.help = false }
      this.$store.commit('panorama/setShowLateral', false)
      this.$store.dispatch('panorama/getPanoByPoint', this.latLngClick)
      this.$store.commit('panorama/setHead', { head: null, from: 'mapClick' })
    },
    updateOrientation () {
      if (!this.latLng) {
        return
      }
      const { head } = this.pano.getHead()
      if (this.headFrom !== 'panoOrientation' && this.head !== head) {
        this.pano.setOrientation(this.head, this.headFrom)
      }
    },
    updateHeadFromClick () {
      if (this.latLngClick !== null && (this.head === null || this.head === 0)) {
        const head = 90 - Math.atan2((this.latLngClick.lng - this.latLng.lng), (this.latLngClick.lat - this.latLng.lat)) * 180 / Math.PI
        this.$store.commit('panorama/setHead', { head, from: 'mapClick' })
      }
    },
    updateHeadFromPanoramaOrientation () {
      const { head, headFrom } = this.pano.getHead()
      this.$store.commit('panorama/setHead', { head, from: headFrom })
    },
    updatePano () {
      this.pano.setLatLng(this.latLng, this.head, 'mapClick')
    },
    updateMarker () {
      if (this.latLng) {
        this.marker.setLatLng(this.latLng)
      } else {
        this.marker.setLatLng({ lat: -9999, lng: -9999 })
      }
    },
    removePanoramasLayer () {
      if (!this.panoramasLayer) {
        return
      }
      let panoramasOverlayer = this.$store.state.map.layers.overlays.filter(layer => layer.id.plainRef === this.panoramasLayer.id.plainRef)
      panoramasOverlayer = panoramasOverlayer.length > 0 && panoramasOverlayer[0]
      if (this.addPanoramasLayerSwitch && panoramasOverlayer) {
        this.$store.dispatch('map/removeOverlay', panoramasOverlayer)
      }
    },
    activateClickBehaviour () {
      this.map.on('click', this.clickHandler)
    },
    cancelClickBehaviour () {
      this.map.off('click', this.clickHandler)
    },
    showDrawingNavigationWindow () {
      this.$store.commit('panorama/setShowDrawingNavigationWindow', true)
    }
  }
}
</script>

<style lang="scss" scope>
.panoramaview-panel {
  height: 100%;

  .panel-content {
    height: 100%;
  }

  .panorama-view-container {
    flex-grow: 1;
  }

  .panorama-view__container {
    min-height: 100px;
  }
}
.panorama-view-marker {
  fill: #fdc02d;
  stroke: black;
  stroke-width: 4;
}
</style>
